var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.2 31.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31.05v-4.7c0-1.17,.3-2.22,.9-3.17,.6-.95,1.43-1.66,2.5-2.12,2.43-1.07,4.62-1.83,6.57-2.3,1.95-.47,3.96-.7,6.02-.7s4.07,.23,6,.7c1.93,.47,4.12,1.23,6.55,2.3,1.07,.47,1.91,1.18,2.53,2.12,.62,.95,.92,2.01,.92,3.17v4.7H0Zm35,0v-4.7c0-2.1-.53-3.83-1.6-5.17s-2.47-2.44-4.2-3.27c2.3,.27,4.47,.66,6.5,1.17s3.68,1.11,4.95,1.77c1.1,.63,1.97,1.42,2.6,2.35,.63,.93,.95,1.98,.95,3.15v4.7h-9.2ZM16,15c-2.2,0-4-.7-5.4-2.1-1.4-1.4-2.1-3.2-2.1-5.4s.7-4,2.1-5.4C12,.7,13.8,0,16,0s4,.7,5.4,2.1c1.4,1.4,2.1,3.2,2.1,5.4s-.7,4-2.1,5.4-3.2,2.1-5.4,2.1Zm18-7.5c0,2.2-.7,4-2.1,5.4-1.4,1.4-3.2,2.1-5.4,2.1-.37,0-.77-.02-1.23-.08s-.86-.14-1.23-.27c.8-.83,1.41-1.86,1.83-3.08s.62-2.58,.62-4.07-.21-2.82-.62-3.98c-.42-1.15-1.03-2.21-1.83-3.18,.37-.1,.77-.18,1.23-.25,.45-.07,.86-.1,1.23-.1,2.2,0,4,.7,5.4,2.1,1.4,1.4,2.1,3.2,2.1,5.4ZM3,28.05H29v-1.7c0-.53-.16-1.05-.48-1.55s-.71-.85-1.17-1.05c-2.4-1.07-4.42-1.78-6.05-2.15-1.63-.37-3.4-.55-5.3-.55s-3.68,.18-5.32,.55c-1.65,.37-3.68,1.08-6.08,2.15-.47,.2-.85,.55-1.15,1.05s-.45,1.02-.45,1.55v1.7ZM16,12c1.3,0,2.38-.42,3.23-1.27,.85-.85,1.27-1.93,1.27-3.23s-.42-2.38-1.27-3.23-1.93-1.28-3.23-1.28-2.38,.43-3.23,1.27c-.85,.85-1.28,1.93-1.27,3.23,0,1.3,.43,2.38,1.27,3.23,.85,.85,1.93,1.27,3.23,1.27Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.54d89d7ee6be38660be11e58fc0782d3.svg";
export { ForwardRef as ReactComponent };